export default __webpack_public_path__ + "static/media/cleanproStep1.f63e7fe7.png";